var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.label_class ? _vm.label_class : 'inline-block leading-snug font-semibold text-gray-warm-800 text-label pb-1 pr-6',attrs:{"for":_vm.for_element}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }